import axios from 'axios';
import { Auth} from 'aws-amplify';
const STOP_REGION = process.env.REACT_APP_STOP_REGION


export const getStopApi = async (params) => {
  const { commonParams, authorization } = params;
  const config = {
    headers: {
      Authorization: authorization,
      Region: STOP_REGION
    },
  };
  const response = await axios
    .get(commonParams, config)
    .then((response) => {
      //alert(JSON.stringify(response))
      if (response.data?.statusCode && response.data?.statusCode != 200)
        throw {'response': response.data};  
      return response;
    })
    .catch((e) => {
      //console.log(e);
      //return e;
      if (e.response?.status === 401) {
        Auth.signOut();
        return {'response': 'Session Expired'};
      }
      else
        throw JSON.stringify(e.response?.data?.errors ? e.response.data.errors : e.response?.data ? e.response.data : e.response ? e.response : e);
    });

  const data = await response.data;
  return data === undefined ? null : data;
};

export const setStopApi = async (params) => {
  const { url, payload, authorization } = params;
  const config = {
    headers: {
      Authorization: authorization,
      Region: STOP_REGION
    },
  };
  const response = await axios
    .put(url, payload, config)
    .then((response) => {
      if (response.data?.statusCode && response.data?.statusCode != 200)
        throw {'response': response.data};  
      return response;
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        Auth.signOut();
        return {'response': 'Session Expired'};
      }
      else
        throw JSON.stringify(e.response?.data?.errors ? e.response.data.errors : e.response?.data ? e.response.data : e.response ? e.response : e);
    });

  const data = await response.data;
  return data === undefined ? null : data;
};

export const deleteStopApi = async (params) => {
  const { url, payload, authorization } = params;
  const config = {
    data: payload,
    headers: {
      Authorization: authorization,
      Region: STOP_REGION
    },
  };
  const response = await axios
    .delete(url, config)
    .then((response) => {
      if (response.data?.statusCode && response.data?.statusCode != 200)
        throw {'response': response.data};  
      return response;
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        Auth.signOut();
        return {'response': 'Session Expired'};
      }
      else
        throw JSON.stringify(e.response?.data?.errors ? e.response.data.errors : e.response?.data ? e.response.data : e.response ? e.response : e);
    });

  const data = await response.data;
  return data === undefined ? null : data;
};

export const postStopApi = async (params) => {
  const { url, payload, authorization } = params;
  const config = {
    headers: {
      Authorization: authorization,
      Region: STOP_REGION
    },
  };
  const response = await axios
    .post(url, payload, config)
    .then((response) => {
      if (response.data?.statusCode && response.data?.statusCode != 200)
        throw {'response': response.data};  
      return response;
    })
    .catch((e) => {
      if (e.response?.status === 401) {
        Auth.signOut();
        return {'response': 'Session Expired'};
      }
      else
        throw JSON.stringify(e.response?.data?.errors ? e.response.data.errors : e.response?.data ? e.response.data : e.response ? e.response : e);
    });

  const data = await response.data;
  return data === undefined ? null : data;
};
